import { HarnessCapability } from "@cohesive/api-client";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { orgAPI } from "./api";

/**
 * The runtimes the current user may start a chat on, with the models each accepts. Server-owned:
 * availability and the sentence explaining an unavailable one both come from here.
 *
 * Cached for five minutes because the answer only moves when the user's provider credentials or
 * the harness-runtime flag change — the credential mutations invalidate it directly.
 */
export function useHarnessCapabilities(
  options?: Partial<UseQueryOptions<HarnessCapability[], AxiosError>>,
) {
  return useQuery<HarnessCapability[], AxiosError>({
    queryKey: ["harnessCapabilities"],
    queryFn: async () => {
      return await orgAPI.harnessCapabilities.list();
    },
    staleTime: 5 * 60 * 1000,
    ...options,
  });
}
